<template>
    <div class="partners">
        <div class="partners__container" :class="{ 'md:container my-5': !blok.FullWidth }" :style="backgroundColor">
            <h4 class="partners__title" :style="partnerTitleStyles">
                {{ blok.title }}
            </h4>
            <ul class="partners__list" :style="gap">
                <template v-for="partner in partnersWithImageClass" :key="partner.image.id">
                    <li
                        :class="`partners__list-item partners__list-item--${partner.imageClass} ${blok.FullWidth ? 'height-auto' : ''}`"
                    >
                        <NuxtImg
                            v-if="partner.image?.filename"
                            :src="partner.image.filename"
                            :title="partner.image.title"
                            :alt="partner.image.alt"
                            provider="storyblok"
                            format="webp"
                            loading="lazy"
                            class="partners__list-image"
                        />
                    </li>
                </template>
            </ul>
        </div>
    </div>
</template>

<script setup lang="ts">
import footerData from '~/src/footerData.json';
import type { IL4Partner, IL4Partners } from '~/types/components/L4Partners';

const props = defineProps<{ blok: IL4Partners }>();

const {
    params: { type = 'airport-parking' },
} = useRoute();

const { partners } = props.blok;

const backgroundColor = computed(
    () => `${props.blok.BackgroundColor?.color ? `background-color: ${props.blok.BackgroundColor?.color};` : ''}`
);

const gap = computed(() => `${props.blok.ImagesGap ? `column-gap: ${props.blok.ImagesGap}rem;` : ''}`);

const partnerTitleStyles = computed(() => {
    return [
        `${props.blok.TitleBottomMargin ? `margin-bottom: ${props.blok.TitleBottomMargin}rem;` : ''}`,
        `${props.blok.TitleFontSize ? `font-size: ${props.blok.TitleFontSize}px;` : ''}`,
        `${props.blok.TitleFontWeight ? `font-weight: ${props.blok.TitleFontWeight};` : ''}`,
        `${props.blok.TitleColor?.color ? `color: ${props.blok.TitleColor?.color};` : ''}`,
    ];
});

// Classes added because of very strict layout on original site
const partnersWithImageClass = computed(() =>
    partners.map(({ image }: IL4Partner) => {
        return {
            imageClass: image.title,
            image,
        };
    })
);
</script>

<style lang="postcss" scoped>
.partners {
    @apply text-center;
    &__container {
        @apply p-4 lg:p-9;
    }
    &__title {
        @apply mb-4 text-bodypurple;
    }
    &__list {
        @apply flex flex-wrap justify-center items-center gap-x-8 px-4;
        &-item {
            @apply py-2 box-content relative;
        }
        &-image {
            @apply w-full h-full;
        }
    }
    .partners__list-item {
        @apply h-5 object-contain;
        &--virgin-australia-logo {
            @apply h-8 -top-1;
        }
        &--emirates-logo {
            @apply h-[41px] top-[-3px];
        }
        &--hrg-logo {
            @apply h-[27px];
        }
        &--air-france-logo {
            @apply h-3.5 top-px;
        }
        &--alitalia-logo {
            @apply h-6 -top-0.5;
        }
        &--ryan-air-logo {
            @apply h-3.5 top-px;
        }
        &--jetstar-logo {
            @apply h-6;
        }
        &.height-auto {
            @apply h-auto;
        }
    }
}
</style>
